<template>
  <v-card
    class="ma-0 pa-0 pt-2 px-1 create-simple-product-card"
    width="100%"
    flat
    :style="cardHeightStyle"
  >
    <v-app-bar
      flat
      class="my-0 mb-2 py-1 px-2 create-simple-product-header"
      :style="toolbarTitle ? { paddingTop: '10px' } : null"
      dense
      height="20"
    >
      <v-toolbar-title class="create-simple-product-title">
        <span class="me-2" v-if="toolbarTitle">
          {{ $t("product") }} / {{ $t("service") }}</span
        >
        <div v-if="showTypeSelector" class="product-type-toggle mt-2">
          <button
            type="button"
            :disabled="!!id"
            class="toggle-item"
            :class="{ active: type === 'product' }"
            @click="type = 'product'"
          >
            {{ $t("product") }}
          </button>
          <button
            type="button"
            :disabled="!!id"
            class="toggle-item"
            :class="{ active: type === 'service' }"
            @click="type = 'service'"
          >
            {{ $t("service") }}
          </button>
        </div>
      </v-toolbar-title>
      <v-checkbox
        v-if="!simple"
        v-model="status"
        :class="[toolbarTitle ? 'mt-6' : 'mt-2', 'mx-3']"
        :label="$t('status') + '  :  ' + (status ? $t('active') : $t('deactive'))"
        value="active"
      />
      <v-tooltip bottom :disabled="!wasVariableProduct">
        <template v-slot:activator="{ on, attrs }">
          <div v-bind="attrs" v-on="on">
            <v-checkbox
              v-if="!simple && type === 'product'"
              v-model="isVariableProduct"
              :disabled="!!id || wasVariableProduct"
              :class="[toolbarTitle ? 'mt-6' : 'mt-2', 'mx-4']"
              :label="$t('variant-product')"
            />
          </div>
        </template>
        <span>{{ $t("cannot-unset-variable-product") }}</span>
      </v-tooltip>
      <v-checkbox
        v-if="!simple && type === 'product'"
        v-model="has_serial"
        true-value="active"
        false-value="deactive"
        :class="[toolbarTitle ? 'mt-6' : 'mt-2', 'mx-2']"
        :label="$t('product-serial')"
      />
      <!-- <v-checkbox
        v-if="!simple"
        v-model="isVariableProduct"
        :class="[toolbarTitle ? 'mt-6' : 'mt-2', 'mx-4']"
        :label="$t('variant-product')"
      /> -->
      <v-spacer />
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="id"
            v-bind="attrs"
            icon
            small
            class="float-left"
            v-on="on"
            @click="goTo($route.name == 'Product' ? 'Product' : 'Service')"
          >
            <v-icon color="teal" style="font-size: 22px"> mdi-plus-box-outline </v-icon>
          </v-btn>
        </template>
        <span>{{ $t("product") }} / {{ $t("service") }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="!formType"
            v-bind="attrs"
            icon
            small
            v-on="on"
            @click="goTo(type == 'product' ? 'ProductList' : 'ServiceList')"
          >
            <v-icon color="primary" style="font-size: 22px">
              mdi-format-list-numbered
            </v-icon>
          </v-btn>
        </template>
        <span>{{ type == "product" ? $t("productList") : $t("serviceList") }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="!formType"
            v-bind="attrs"
            icon
            small
            v-on="on"
            @click="$router.go(-1)"
          >
            <v-icon color="primary" style="font-size: 22px"> mdi-arrow-left </v-icon>
          </v-btn>
        </template>
        <span>{{ $t("back") }}</span>
      </v-tooltip>
    </v-app-bar>
    <v-progress-linear
      :active="!render"
      :indeterminate="!render"
      absolute
      bottom
      style="top: -4px"
      color="primary"
    />
    <v-form
      v-if="render"
      :key="'csp-form-' + formResetKey"
      ref="form"
      v-model="valid"
      lazy-validation
      class="create-simple-product-form"
    >
      <v-container v-if="simple" class="mt-3 create-simple-product-advance-scroll">
        <v-row class="">
          <v-col cols="12">
            <div class="d-flex align-center">
              <span class="me-2 text-body-1">
                {{ $t("specifications") }}
              </span>
              <v-divider class="flex-grow-1"></v-divider>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="1" class="pe-0">
            <file-picker
              ref="refFilePicker"
              v-model="imagePicker"
              :label="$t('uploadImage')"
              :avatar="true"
              :multiple="false"
              extensions="image/png, image/gif, image/jpeg"
              type-prop="productAvatar"
              :val="imagePickerVal ? imagePickerVal : null"
            />
          </v-col>
          <v-col
            cols="12"
            md="11"
            class="ps-0"
            :class="{
              'create-simple-product-advance-inputs-col-desktop': !isMobile,
              'create-simple-product-advance-inputs-col-mobile': isMobile,
            }"
          >
            <v-row>
              <v-col cols="12" md="3" sm="3" class="mb-0">
                <v-text-field
                  v-model="name"
                  :label="$t('name')"
                  :rules="[(v) => !!v || $t('is-required')]"
                  :hide-details="false"
                  height="20"
                  dense
                  outlined
                  class="mb-1 dense"
                  autofocus
                  clearable
                />
              </v-col>
              <v-col v-show="type == 'product'" cols="12" md="3" sm="3" class="mb-0">
                <v-text-field
                  v-model="barcode"
                  :label="$t('barcode')"
                  height="20"
                  dense
                  outlined
                  class="mb-1 dense"
                  clearable
                />
              </v-col>
              <v-col cols="12" md="3" sm="3" class="mb-0 pb-0" style="height: 55px">
                <aicomplete
                  ref="refUnit"
                  v-model="unit"
                  :val="unit"
                  title="unit"
                  type="unit"
                  :set-init="true"
                />
              </v-col>
              <v-col v-show="type == 'product'" cols="12" md="3" sm="3" class="mb-0">
                <autocomplete
                  v-model="kind"
                  :title="$t('productKind')"
                  type="productKind"
                  :value="kind"
                />
              </v-col>
              <v-col cols="12" md="3" sm="3">
                <autocomplete
                  v-model="branch"
                  :title="$t('branch')"
                  type="branch"
                  :value="branch"
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row class="">
          <v-col cols="11">
            <div class="d-flex align-center">
              <span class="me-2 text-body-1">
                {{ $t("tax&priceing") }}
              </span>
              <v-divider class="flex-grow-1"></v-divider>
            </div>
          </v-col>
        </v-row>
        <v-row class="mb-2">
          <v-col cols="12" md="3" sm="3" class="mb-0">
            <v-text-field
              v-model="taxid"
              :label="$t('taxisProduct')"
              height="20"
              dense
              type="number"
              outlined
              class="mb-1 dense"
              clearable
            />
          </v-col>
          <v-col cols="12" md="3" sm="3" class="mb-0">
            <v-text-field
              v-model="taxPercent"
              :label="$t('taxPercent')"
              height="20"
              dense
              type="number"
              outlined
              class="mb-1 dense"
              clearable
            />
          </v-col>
          <v-col cols="12" sm="3" md="3" class="mb-1">
            <money
              v-model="price"
              :label="$t('fixSellPrice')"
              :dense="true"
              :outlined="true"
              :solo="false"
              :clearable="true"
              value-when-is-empty=""
              :options="options"
              @input="calcPriceWithTax"
            />
          </v-col>
          <v-col cols="12" sm="3" md="3" class="mb-1">
            <money
              v-model="priceWithTax"
              :label="$t('priceWithTax')"
              :dense="true"
              :outlined="true"
              :solo="false"
              :clearable="true"
              value-when-is-empty=""
              :options="options"
              @input="calcPrice"
            />
          </v-col>
          <v-col cols="12" sm="3" md="3" class="mb-1">
            <money
              v-model="discount"
              :label="$t('discount')"
              :dense="true"
              :outlined="true"
              :solo="false"
              :clearable="true"
              value-when-is-empty=""
              :options="options"
            />
          </v-col>
          <v-col cols="12" md="3" sm="3" class="mb-0">
            <v-text-field
              v-model="discountPercent"
              :label="$t('discountPercent')"
              height="20"
              dense
              type="number"
              outlined
              class="mb-1 dense"
              clearable
            />
          </v-col>
        </v-row>
        <v-row v-if="type === 'product' && kind && kind.id === 112" class="mb-2">
          <v-col cols="12" md="3" sm="3" class="mb-0">
            <v-text-field
              v-model="constructionWagesPercent"
              :label="$t('construction_wages_percent')"
              height="20"
              dense
              type="number"
              outlined
              class="mb-1 dense"
              clearable
            />
          </v-col>
          <v-col cols="12" md="3" sm="3" class="mb-0">
            <v-text-field
              v-model="profitPercent"
              :label="$t('profit_percent')"
              height="20"
              dense
              type="number"
              outlined
              class="mb-1 dense"
              clearable
            />
          </v-col>
          <v-col cols="12" md="3" sm="3" class="mb-0">
            <v-text-field
              v-model="commissionPercent"
              :label="$t('commission_percent')"
              height="20"
              dense
              type="number"
              outlined
              class="mb-1 dense"
              clearable
            />
          </v-col> </v-row
      ></v-container>

      <div v-if="!simple" class="create-simple-product-simple-shell">
        <v-tabs v-model="productTab" class="create-simple-product-tabs mt-3">
          <v-tab>{{ $t("specifications") }}</v-tab>
          <v-tab v-if="isVariableProduct">{{ $t("variant-product") }}</v-tab>
          <v-tab v-if="!isVariableProduct">{{ $t("pricing") }} {{ $t("advance") }}</v-tab>
          <v-tab v-if="!isVariableProduct">{{ $t("Integrator") }}</v-tab>
          <v-tab v-if="$store.state.shopSystem && !isVariableProduct">
            {{ $t("shop") }}
          </v-tab>
          <v-tab-item class="pt-2">
            <v-container>
              <v-row>
                <v-col cols="12" md="1" class="pe-0">
                  <file-picker
                    ref="refFilePicker"
                    v-model="imagePicker"
                    :label="$t('uploadImage')"
                    :avatar="true"
                    :multiple="false"
                    extensions="image/png, image/gif, image/jpeg"
                    type-prop="productAvatar"
                    :val="imagePickerVal ? imagePickerVal : null"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="11"
                  class="ps-0"
                  :class="{
                    'create-simple-product-advance-inputs-col-desktop': !isMobile,
                    'create-simple-product-advance-inputs-col-mobile': isMobile,
                  }"
                >
                  <v-row>
                    <v-col cols="12" md="3" sm="3" class="mb-0">
                      <v-text-field
                        v-model="name"
                        :label="$t('name')"
                        :rules="[(v) => !!v || $t('is-required')]"
                        :hide-details="false"
                        height="20"
                        dense
                        outlined
                        class="mb-1 dense"
                        autofocus
                        clearable
                      />
                    </v-col>
                    <v-col
                      v-show="type == 'product' && !isVariableProduct"
                      cols="12"
                      md="3"
                      class="mb-0"
                    >
                      <v-text-field
                        v-model="barcode"
                        :label="$t('barcode')"
                        height="20"
                        dense
                        outlined
                        class="mb-1 dense"
                        clearable
                      />
                    </v-col>
                    <v-col v-if="!isVariableProduct" cols="12" md="2" class="mb-0">
                      <v-text-field
                        v-model="code"
                        :label="$t('code')"
                        height="20"
                        dense
                        outlined
                        class="mb-1 dense"
                        clearable
                        @blur="checkCode"
                      />
                    </v-col>
                    <v-col cols="12" md="2" class="mb-0 pb-0" style="height: 55px">
                      <aicomplete
                        ref="refUnit"
                        v-model="unit"
                        :val="unit"
                        title="unit"
                        type="unit"
                        :set-init="true"
                      />
                    </v-col>
                    <v-col cols="12" md="2" class="mb-0 pb-0" style="height: 55px">
                      <v-text-field
                        v-model="displayPriority"
                        :label="$t('displayPriority')"
                        height="20"
                        dense
                        type="number"
                        outlined
                        class="mb-1 dense"
                        clearable
                      />
                    </v-col>
                    <v-col
                      v-if="!isVariableProduct"
                      cols="12"
                      md="3"
                      class="mb-0 pb-0"
                      style="height: 55px"
                    >
                      <v-text-field
                        v-model="custom_code"
                        :label="$t('Custom financial ID')"
                        outlined
                        clearable
                        dense
                      />
                    </v-col>
                    <v-col
                      v-show="type == 'product'"
                      cols="12"
                      md="3"
                      sm="3"
                      class="mb-0"
                    >
                      <autocomplete
                        v-model="kind"
                        :title="$t('productKind')"
                        type="productKind"
                        :value="kind"
                      />
                    </v-col>
                    <v-col cols="12" md="6">
                      <description ref="refContent" v-model="content" type="product" />
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-expansion-panels v-model="panel" class="mt-8">
                <v-expansion-panel>
                  <v-expansion-panel-header style="font-size: 14px">
                    <div>
                      <div>{{ $t("tax&priceing") }}</div>
                      <div class="abr-subtitle mt-2">
                        {{ $t("taxisProduct") }} , {{ $t("taxPercent") }} ,
                        {{ $t("fixSellPrice") }} , {{ $t("discount") }} , ...
                      </div>
                    </div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row class="mb-2">
                      <v-col cols="12" md="3" sm="3" class="mb-0">
                        <v-text-field
                          v-model="taxid"
                          :label="$t('taxisProduct')"
                          height="20"
                          dense
                          type="number"
                          outlined
                          class="mb-1 dense"
                          clearable
                        />
                      </v-col>
                      <v-col cols="12" md="3" sm="3" class="mb-0">
                        <v-text-field
                          v-model="taxPercent"
                          :label="$t('taxPercent')"
                          height="20"
                          dense
                          type="number"
                          outlined
                          class="mb-1 dense"
                          clearable
                        />
                      </v-col>
                      <v-col
                        v-if="!isVariableProduct"
                        cols="12"
                        sm="3"
                        md="3"
                        class="mb-1"
                      >
                        <money
                          v-model="price"
                          :label="$t('fixSellPrice')"
                          :dense="true"
                          :outlined="true"
                          :solo="false"
                          :clearable="true"
                          value-when-is-empty=""
                          :options="options"
                          @input="calcPriceWithTax"
                        />
                      </v-col>
                      <v-col
                        v-if="!isVariableProduct"
                        cols="12"
                        sm="3"
                        md="3"
                        class="mb-1"
                      >
                        <money
                          v-model="priceWithTax"
                          :label="$t('priceWithTax')"
                          :dense="true"
                          :outlined="true"
                          :solo="false"
                          :clearable="true"
                          value-when-is-empty=""
                          :options="options"
                          @input="calcPrice"
                        />
                      </v-col>
                      <v-col
                        v-if="!isVariableProduct"
                        cols="12"
                        sm="3"
                        md="3"
                        class="mb-1"
                      >
                        <money
                          v-model="discount"
                          :label="$t('discount')"
                          :dense="true"
                          :outlined="true"
                          :solo="false"
                          :clearable="true"
                          value-when-is-empty=""
                          :options="options"
                        />
                      </v-col>
                      <v-col
                        v-if="!isVariableProduct"
                        cols="12"
                        md="3"
                        sm="3"
                        class="mb-0"
                      >
                        <v-text-field
                          v-model="discountPercent"
                          :label="$t('discountPercent')"
                          height="20"
                          dense
                          type="number"
                          outlined
                          class="mb-1 dense"
                          clearable
                        />
                      </v-col>
                      <!-- add kalabarg -->
                      <v-col
                        v-if="!isVariableProduct"
                        cols="12"
                        md="3"
                        sm="3"
                        class="mb-0 d-flex align-center"
                      >
                        <v-checkbox
                          v-model="isKalaBarg"
                          :label="$t('isKalaBarg')"
                          class="mt-0"
                          hide-details
                        />
                      </v-col>
                    </v-row>
                    <v-row
                      v-if="type === 'product' && kind && kind.id === 112"
                      class="mb-2"
                    >
                      <v-col cols="12" md="3" sm="3" class="mb-0">
                        <v-text-field
                          v-model="constructionWagesPercent"
                          :label="$t('construction_wages_percent')"
                          height="20"
                          dense
                          type="number"
                          outlined
                          class="mb-1 dense"
                          clearable
                        />
                      </v-col>
                      <v-col cols="12" md="3" sm="3" class="mb-0">
                        <v-text-field
                          v-model="profitPercent"
                          :label="$t('profit_percent')"
                          height="20"
                          dense
                          type="number"
                          outlined
                          class="mb-1 dense"
                          clearable
                        />
                      </v-col>
                      <v-col cols="12" md="3" sm="3" class="mb-0">
                        <v-text-field
                          v-model="commissionPercent"
                          :label="$t('commission_percent')"
                          height="20"
                          dense
                          type="number"
                          outlined
                          class="mb-1 dense"
                          clearable
                        />
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel v-show="type == 'product' && !isVariableProduct">
                  <v-expansion-panel-header style="font-size: 14px">
                    <div>
                      <div>{{ $t("otherBarcodes") }}</div>
                      <div class="abr-subtitle mt-2">
                        {{ $t("otherBarcodesDescrible") }}
                      </div>
                    </div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row class="mb-3">
                      <v-col cols="12" sm="3">
                        <v-btn color="primary" small outlined @click="addBarcode">
                          {{ $t("addBarcode") }}
                          <v-icon class="ms-2"> mdi-plus </v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row v-for="(item, i) in barcodes" :key="i">
                      <v-col cols="12" md="4" class="mb-0">
                        <v-text-field
                          v-model="item.value"
                          :label="$t('barcode')"
                          height="20"
                          dense
                          :rules="[(v) => !!v || $t('is-required')]"
                          outlined
                          class="mb-1 dense"
                          clearable
                        />
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-btn
                          color="pink"
                          small
                          outlined
                          height="32"
                          @click="removeBarcode(item)"
                        >
                          <v-icon> mdi-trash-can-outline </v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <v-expansion-panel-header style="font-size: 14px">
                    <div>
                      <div>{{ $t("grouping,tags") }}</div>
                      <div class="abr-subtitle mt-2">
                        {{ $t("tag") }} , {{ $t("group") }} , {{ $t("category") }} , ...
                      </div>
                    </div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row class="mb-2">
                      <v-col
                        class="mb-0 pb-0"
                        style="height: 55px"
                        cols="12"
                        md="3"
                        sm="3"
                      >
                        <aicomplete
                          ref="refGroup"
                          v-model="group"
                          :val="group"
                          title="main-group"
                          type="productGroup"
                          :data="JSON.stringify({ parent: 0, type: 'group' })"
                          :new-btn="true"
                          :set-init="!id ? true : false"
                        />
                      </v-col>
                      <v-col
                        class="mb-0 pb-0"
                        style="height: 55px"
                        cols="12"
                        md="3"
                        sm="3"
                      >
                        <aicomplete
                          ref="refCat1"
                          v-model="cat1"
                          :val="cat1"
                          title="other-group"
                          type="productGroup"
                          :data="
                            JSON.stringify({
                              parent: group ? group.id : null,
                              type: 'category',
                            })
                          "
                          :new-btn="true"
                          :set-init="!id ? true : false"
                        />
                      </v-col>
                      <v-col
                        class="mb-0 pb-0"
                        style="height: 55px"
                        cols="12"
                        md="3"
                        sm="3"
                      >
                        <aicomplete
                          ref="refCat2"
                          v-model="cat2"
                          :val="cat2"
                          title="category"
                          type="productGroup"
                          :data="
                            JSON.stringify({
                              parent: cat1 ? cat1.id : null,
                              type: 'subcategory',
                            })
                          "
                          :new-btn="true"
                          :set-init="!id ? true : false"
                        />
                      </v-col>
                      <v-col cols="12" md="3" sm="3">
                        <tag v-model="tag" :solo="false" :input="tag" />
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel v-show="type == 'product'">
                  <v-expansion-panel-header style="font-size: 14px">
                    <div>
                      <div>{{ $t("dimensions") }}</div>
                      <div class="abr-subtitle mt-2">
                        {{ $t("weight") }} , {{ $t("length") }} , {{ $t("width") }} ,
                        {{ $t("height") }}
                      </div>
                    </div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col cols="12" sm="4" md="4" class="">
                        <v-text-field
                          v-model="length"
                          :label="$t('length')"
                          height="20"
                          dense
                          outlined
                          class="mb-1 dense"
                          clearable
                          type="number"
                        />
                      </v-col>
                      <v-col cols="12" sm="4" md="4" class="">
                        <v-text-field
                          v-model="width"
                          :label="$t('width')"
                          height="20"
                          dense
                          outlined
                          class="mb-1 dense"
                          clearable
                          type="number"
                        />
                      </v-col>
                      <v-col cols="12" sm="4" md="4" class="">
                        <v-text-field
                          v-model="height"
                          :label="$t('height')"
                          height="20"
                          dense
                          outlined
                          class="mb-1 dense"
                          clearable
                          type="number"
                        />
                      </v-col>
                    </v-row>
                    <v-row class="mb-2">
                      <v-col cols="12" md="4" class="mb-0">
                        <v-text-field
                          v-model="weight"
                          :label="$t('weight') + '(kg)'"
                          height="20"
                          dense
                          type="number"
                          outlined
                          class="mb-1 dense"
                          clearable
                        />
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel
                  v-show="
                    $store.state.isMainYear && type == 'product' && !isVariableProduct
                  "
                >
                  <v-expansion-panel-header style="font-size: 14px">
                    <div>
                      <div>{{ $t("initial-stock") }}</div>
                      <div class="abr-subtitle mt-2">
                        {{ $t("initialStockInOtherEntrepot") }}
                      </div>
                    </div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col cols="12" sm="3">
                        <v-btn
                          v-show="initialCheck"
                          color="primary"
                          small
                          outlined
                          class="mt-2"
                          @click="addInitialStock"
                        >
                          {{ $t("addInitialStock") }}
                          <v-icon class="ms-2"> mdi-plus </v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row
                      v-for="(initial, i) in initial_stocks"
                      v-show="$store.state.isMainYear && type == 'product'"
                      :key="i"
                      class="mb-2"
                    >
                      <v-col cols="12" sm="3">
                        <v-text-field
                          v-model="initial.stock"
                          :label="$t('count')"
                          height="20"
                          dense
                          outlined
                          class="mb-1 dense"
                          clearable
                          :disabled="!initialCheck"
                          type="number"
                          @input="validateStock(initial)"
                        />
                      </v-col>
                      <v-col cols="12" sm="3" md="3" class="mb-1">
                        <money
                          v-model="initial.price"
                          :label="$t('fee')"
                          :dense="true"
                          :outlined="true"
                          :solo="false"
                          :clearable="true"
                          value-when-is-empty="0"
                          :disabled="!initialCheck"
                          :options="options"
                        />
                      </v-col>
                      <v-col
                        class="mb-0 pb-0"
                        cols="12"
                        md="4"
                        sm="4"
                        style="height: 55px"
                      >
                        <autocomplete
                          ref="refEntrepot"
                          v-model="initial.entrepot"
                          :rules="entrepotRuls(initial)"
                          :title="$t('entrepot')"
                          :value="entrepot"
                          :hide-details="false"
                          type="entrepot"
                          :disabled="!initialCheck"
                          @input="checkEntrepot(initial, i)"
                        />
                      </v-col>
                      <v-col
                        class="mb-0 pb-0"
                        cols="12"
                        md="2"
                        sm="2"
                        style="height: 55px"
                      >
                        <v-btn
                          v-show="initialCheck"
                          color="pink"
                          small
                          outlined
                          height="32"
                          @click="removeInitialStock(i)"
                        >
                          <v-icon> mdi-trash-can-outline </v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel v-show="type == 'product'">
                  <v-expansion-panel-header style="font-size: 14px">
                    <div>
                      <div>{{ $t("otherUnits") }}</div>
                      <div class="abr-subtitle mt-2">
                        {{ $t("initialStockInOtherEntrepot") }}
                      </div>
                    </div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row v-show="type == 'product'" class="mb-3">
                      <v-col cols="12" sm="3">
                        <v-btn color="primary" small outlined @click="addUnitRow">
                          {{ $t("addSub-unit") }}
                          <v-icon class="ms-2"> mdi-plus </v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row v-for="(item, i) in units" v-show="type == 'product'" :key="i">
                      <v-col class="mb-0 pb-0" cols="12" md="2" style="height: 55px">
                        <autocomplete
                          v-model="item.unit"
                          :rules="[(v) => !!v || $t('is-required')]"
                          :title="$t('unit')"
                          :value="item.unit"
                          type="unit"
                          :set-init="true"
                        />
                      </v-col>
                      <v-col cols="12" md="2" class="pt-5">
                        1 {{ item.unit ? item.unit.name : "" }} =
                        {{ item.value ? item.value : 1 }} {{ unit.name }}
                      </v-col>
                      <v-col cols="12" md="2" class="mb-0">
                        <v-text-field
                          v-model="item.value"
                          :label="$t('value')"
                          height="20"
                          dense
                          :rules="[(v) => !!v || $t('is-required')]"
                          outlined
                          class="mb-1 dense"
                          clearable
                          type="number"
                        />
                      </v-col>
                      <v-col cols="12" md="2" class="mb-0">
                        <v-checkbox
                          v-model="item.default"
                          :label="$t('defaultUnit')"
                          value="active"
                          class="mt-0"
                          @change="clearDefaultUnits(item, i)"
                        />
                      </v-col>
                      <v-col cols="12" sm="4" md="4" class="">
                        <v-btn
                          v-show="initialCheck"
                          color="pink"
                          small
                          outlined
                          height="32"
                          @click="removeUnit(item)"
                        >
                          <v-icon> mdi-trash-can-outline </v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel v-if="!isMobile && customFieldsPermission">
                  <v-expansion-panel-header style="font-size: 14px">
                    <div>
                      <div>{{ $t("customFields") }}</div>
                      <div class="abr-subtitle mt-2">
                        {{ $t("customeFeildDescrible") }}
                      </div>
                    </div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <custom-fields
                      v-model="customFields"
                      :value="customFields"
                      type-prop="productCustomFields"
                      class="px-4"
                    />
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <div>
                      <div>{{ $t("otherSetting") }}</div>
                      <div class="abr-subtitle mt-2">
                        {{ $t("otherSettingDescrible") }}
                      </div>
                    </div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col cols="12" md="3">
                        <autocomplete
                          v-model="branch"
                          :title="$t('branch')"
                          type="branch"
                          :value="branch"
                        />
                      </v-col>
                      <v-col
                        v-show="type == 'product' && !isVariableProduct"
                        cols="12"
                        md="3"
                        sm="3"
                        class="mb-0"
                      >
                        <v-text-field
                          v-model="orderPoint"
                          :label="$t('orderPoint')"
                          height="20"
                          dense
                          type="number"
                          outlined
                          class="mb-1 dense"
                          clearable
                        />
                      </v-col>
                      <v-col
                        v-show="type == 'product'"
                        cols="12"
                        md="3"
                        sm="3"
                        class="mb-0"
                      >
                        <v-select
                          v-model="inventoryMethod"
                          :label="$t('inventoryMethod')"
                          :items="inventoryMethodItems"
                          height="30"
                          dense
                          outlined
                          item-value="value"
                          item-text="text"
                        />
                      </v-col>
                      <v-col
                        v-show="type == 'product'"
                        cols="12"
                        md="3"
                        sm="3"
                        class="mb-0"
                      >
                        <v-select
                          v-model="priceMethod"
                          :label="$t('priceMethod')"
                          :items="priceMethodItems"
                          height="30"
                          dense
                          outlined
                          item-value="value"
                          item-text="text"
                        />
                      </v-col>
                    </v-row>
                    <v-row v-if="!isMobile && customFieldsPermission"> </v-row>
                    <v-row v-show="type == 'product'" class="mb-3" style="height: 28px">
                      <v-subheader>
                        {{ $t("investor") }}
                      </v-subheader>
                      <v-tooltip v-if="!isVariableProduct" bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            v-bind="attrs"
                            icon
                            small
                            class="float-left mt-2"
                            v-on="on"
                            @click="addInvestorRow"
                          >
                            <v-icon color="teal" style="font-size: 22px">
                              mdi-plus-box-outline
                            </v-icon>
                          </v-btn>
                        </template>
                        <span>{{ $t("addInvestor") }}</span>
                      </v-tooltip>
                    </v-row>
                    <v-row
                      v-for="(item, i) in investors"
                      v-show="type == 'product'"
                      :key="i"
                    >
                      <v-col
                        v-if="!isVariableProduct"
                        class="mb-0 pb-0"
                        cols="12"
                        md="3"
                        style="height: 55px"
                      >
                        <autocomplete
                          v-model="item.investor"
                          :rules="[(v) => !!v || $t('is-required')]"
                          :title="$t('investor')"
                          :value="item.investor"
                          type="person"
                          :new-btn="true"
                          :data="JSON.stringify({ type: 'investor' })"
                          @input="changeInvestor(item)"
                        />
                      </v-col>
                      <v-col v-if="!isVariableProduct" cols="12" md="3" class="mb-0">
                        <v-text-field
                          v-model="item.investorSellPercent"
                          :label="$t('investorSellPercent')"
                          height="20"
                          dense
                          :rules="[(v) => !!v || $t('is-required')]"
                          outlined
                          type="number"
                          class="mb-1 dense"
                          clearable
                        />
                      </v-col>
                      <v-col v-if="!isVariableProduct" cols="12" md="3" class="mb-0">
                        <v-text-field
                          v-model="item.investorReturnSellPercent"
                          :label="$t('investorReturnSellPercent')"
                          height="20"
                          dense
                          :rules="[(v) => !!v || $t('is-required')]"
                          outlined
                          type="number"
                          class="mb-1 dense"
                          clearable
                        />
                      </v-col>
                      <v-col cols="12" md="3" class="">
                        <v-tooltip v-if="!isVariableProduct" bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              color="pink"
                              icon
                              small
                              v-bind="attrs"
                              class="ms-2"
                              v-on="on"
                              @click="removeInvestor(item)"
                            >
                              <v-icon color="pink" style="font-size: 22px">
                                mdi-close-box
                              </v-icon>
                            </v-btn>
                          </template>
                          <span>{{ $t("remove") }}</span>
                        </v-tooltip>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <div>
                      <div>{{ $t("image-gallery") }}</div>
                      <div class="abr-subtitle mt-2">
                        {{ $t("upload your images") }}
                      </div>
                    </div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row class="pa-0 ma-0">
                      <v-col cols="12" md="3" class="pa-0">
                        <file-picker
                          ref="refProductImages"
                          v-model="productImages"
                          :label="$t('uploadImage')"
                          :multiple="true"
                          extensions="image/png, image/gif, image/jpeg"
                          type-prop="productImages"
                          :val="productImagesVal ? productImagesVal : null"
                        />
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <!-- add allocation -->
                <v-expansion-panel>
                  <v-expansion-panel-header style="font-size: 14px">
                    <div>
                      <div>{{ $t("allocation") }}</div>
                      <div class="abr-subtitle mt-2 mb-1">
                        {{ $t("allocationProductDescribe") }}
                      </div>
                    </div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row class="mb-3" style="height: 28px">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            v-bind="attrs"
                            icon
                            small
                            class="float-left mt-2"
                            v-on="on"
                            @click="addAllocationRow"
                          >
                            <v-icon color="teal" style="font-size: 22px">
                              mdi-plus-box-outline
                            </v-icon>
                          </v-btn>
                        </template>
                        <span>{{ $t("addAllocation") }}</span>
                      </v-tooltip>
                      <v-subheader class="pa-0 ma-0">
                        {{ $t("allocationPercent") }}
                      </v-subheader>
                    </v-row>
                    <v-row v-for="(item, i) in allocations" :key="'allocation-' + i">
                      <v-col cols="12" md="3" class="mb-0">
                        <v-text-field
                          v-model="item.percent"
                          :placeholder="$t('allocationPercent')"
                          height="20"
                          dense
                          outlined
                          type="number"
                          class="mb-1 dense"
                          hide-details
                          clearable
                          suffix="%"
                        />
                      </v-col>
                      <v-col cols="12" md="3" class="mb-0">
                        <v-text-field
                          :id="'allocationFromDate' + i"
                          v-model="item.from_date"
                          :placeholder="$t('fromDate')"
                          height="20"
                          dense
                          outlined
                          class="mb-1 dense"
                          hide-details
                          clearable
                        />
                        <date-picker
                          v-model="item.from_date"
                          :element="'allocationFromDate' + i"
                          :locale="$store.state.date_locale"
                          :format="$store.state.date_format"
                          auto-submit
                          :color="
                            $vuetify.theme.themes[
                              $vuetify.theme.isDark ? 'dark' : 'light'
                            ].primary
                          "
                        />
                      </v-col>
                      <v-col cols="12" md="3" class="mb-0">
                        <v-text-field
                          :id="'allocationToDate' + i"
                          v-model="item.to_date"
                          :placeholder="$t('toDate')"
                          height="20"
                          dense
                          outlined
                          class="mb-1 dense"
                          hide-details
                          clearable
                        />
                        <date-picker
                          v-model="item.to_date"
                          :element="'allocationToDate' + i"
                          :locale="$store.state.date_locale"
                          :format="$store.state.date_format"
                          auto-submit
                          :color="
                            $vuetify.theme.themes[
                              $vuetify.theme.isDark ? 'dark' : 'light'
                            ].primary
                          "
                        />
                      </v-col>
                      <v-col cols="12" md="3">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              color="pink"
                              icon
                              small
                              v-bind="attrs"
                              class="ms-2"
                              v-on="on"
                              @click="removeAllocation(item)"
                            >
                              <v-icon color="pink" style="font-size: 22px">
                                mdi-close-box
                              </v-icon>
                            </v-btn>
                          </template>
                          <span>{{ $t("remove") }}</span>
                        </v-tooltip>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-container>
          </v-tab-item>
          <v-tab-item v-if="isVariableProduct">
            <variable-product-tab
              v-model="variableVariants"
              :product-name="name"
              :costs="costs"
              :price-method="priceMethod"
              :initial-check="initialCheck"
              :product-type="type"
            />
          </v-tab-item>
          <v-tab-item>
            <pricing
              v-model="pricing"
              :costs="costs"
              :method="priceMethod"
              :value="pricing"
            />
          </v-tab-item>
          <v-tab-item>
            <v-container>
              <v-row class="pa-0 ma-0">
                <v-tabs vertical>
                  <v-tab>
                    <v-icon class="me-3"> mdi-wordpress </v-icon>
                    {{ $t("woocommerce") }}
                  </v-tab>
                  <v-tab align="right">
                    <img width="20" class="me-2" src="@/assets/digikala.png" />
                    {{ $t("digikala") }}
                  </v-tab>
                  <v-tab align="right">
                    <img width="20" class="me-2" src="@/assets/basalam.png" />
                    {{ $t("basalam") }}
                  </v-tab>
                  <v-tab>
                    <img width="20" class="me-4" src="@/assets/markitoLogo.png" />
                    {{ $t("markito") }}
                  </v-tab>
                  <v-tab align="right">
                    <img width="10" class="me-4" src="@/assets/portal.png" />
                    {{ $t("portal") }}
                  </v-tab>
                  <!-- <portal3 /> -->
                  <v-tab align="right">
                    <img width="10" class="me-4" src="@/assets/portal.png" />
                    {{ $t("portal3") }}
                  </v-tab>
                  <v-tab align="right">
                    <img width="20" class="me-4" src="@/assets/sazito.png" />
                    {{ $t("sazito") }}
                  </v-tab>
                  <v-tab align="right">
                    <img width="20" class="me-4" src="@/assets/webzi.png" />
                    {{ $t("webzi") }}
                  </v-tab>
                  <v-tab align="right">
                    <img width="20" class="mx-4" src="@/assets/integrators/mixin.png" />
                    {{ $t("mixin") }}
                  </v-tab>
                  <v-tab align="right">
                    <img
                      width="20"
                      class="mx-4"
                      src="@/assets/integrators/snapShop.png"
                    />
                    {{ $t("snap-shop") }}
                  </v-tab>
                  <v-tab-item>
                    <v-container>
                      <v-row class="mx-0">
                        <v-col cols="6" class="px-0">
                          <v-btn
                            color="primary"
                            class="mr-0"
                            outlined
                            :loading="isLoading"
                            @click="addWoocommerceIdItems"
                          >
                            {{ $t("addId") }}
                          </v-btn>
                        </v-col>
                      </v-row>
                      <v-row v-for="(item, h) in woocommerceIdItems" :key="h">
                        <v-col cols="12" md="3" class="mb-0">
                          <autocomplete
                            v-model="item.woocommercePanelName"
                            :title="$t('woocommercePanelName')"
                            :value="item.woocommercePanelName"
                            type="woocommercePanelName"
                          />
                        </v-col>
                        <v-col cols="12" md="2" class="mb-0">
                          <v-text-field
                            v-model="item.woocommerceId"
                            :label="$t('woocommerceId') + ' ' + (h + 1)"
                            height="20"
                            dense
                            outlined
                            class="mb-1 dense"
                            clearable
                          />
                        </v-col>
                        <v-col cols="12" md="2" class="mb-0">
                          <v-text-field
                            v-model="item.woocommerceVariantId"
                            :label="$t('woocommerceVariantId') + ' ' + (h + 1)"
                            height="20"
                            dense
                            outlined
                            class="mb-1 dense"
                            clearable
                          />
                        </v-col>
                        <v-col cols="12" md="2" class="mb-0">
                          <v-text-field
                            v-model="item.woocommerceFixCount"
                            :label="$t('woocommerceFixCount') + ' ' + (h + 1)"
                            height="20"
                            dense
                            outlined
                            class="mb-1 dense"
                            clearable
                          />
                        </v-col>
                        <v-col cols="12" md="3" class="mb-0">
                          <v-btn
                            color="pink"
                            small
                            outlined
                            height="32"
                            @click="removeWoocommerceId(item)"
                          >
                            <v-icon> mdi-trash-can-outline </v-icon>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-tab-item>
                  <v-tab-item>
                    <digikala-integrator
                      @update="getPanels"
                      :digikalaPanel="digikalaPanel"
                    />
                  </v-tab-item>
                  <v-tab-item>
                    <v-container>
                      <v-row class="mx-0">
                        <v-col cols="6" class="px-0">
                          <v-btn
                            color="primary"
                            class="mr-0"
                            outlined
                            :loading="isLoading"
                            @click="addBaSalamIdItems"
                          >
                            {{ $t("addId") }}
                          </v-btn>
                        </v-col>
                      </v-row>
                      <v-row v-for="(item, h) in basalamIdItems" :key="h">
                        <v-col cols="12" md="3" class="mb-0">
                          <autocomplete
                            v-model="item.basalamPanelName"
                            :title="$t('basalamPanelName')"
                            :value="item.basalamPanelName"
                            type="basalamPanelName"
                          />
                        </v-col>
                        <v-col cols="12" md="2" class="mb-0">
                          <v-text-field
                            v-model="item.basalamId"
                            :label="$t('basalamId') + ' ' + (h + 1)"
                            height="20"
                            dense
                            outlined
                            class="mb-1 dense"
                            clearable
                          />
                        </v-col>
                        <v-col cols="12" md="2" class="mb-0">
                          <v-text-field
                            v-model="item.basalamVariantId"
                            :label="$t('basalamVariantId') + ' ' + (h + 1)"
                            height="20"
                            dense
                            outlined
                            class="mb-1 dense"
                            clearable
                          />
                        </v-col>
                        <v-col cols="12" md="3" class="mb-0">
                          <v-btn
                            color="pink"
                            small
                            outlined
                            height="32"
                            @click="removeBaSalamId(item)"
                          >
                            <v-icon> mdi-trash-can-outline </v-icon>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-tab-item>
                  <v-tab-item>
                    <v-container>
                      <v-row>
                        <v-col cols="12" md="3" sm="3" class="mb-0">
                          <v-text-field
                            v-model="markitoId"
                            :label="$t('markitoId')"
                            height="20"
                            dense
                            outlined
                            class="mb-1 dense"
                            clearable
                          />
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-tab-item>
                  <v-tab-item>
                    <v-container>
                      <v-row>
                        <v-col cols="12" md="3" sm="3" class="mb-0">
                          <v-text-field
                            v-model="portalId"
                            :label="$t('portalId')"
                            height="20"
                            dense
                            outlined
                            class="mb-1 dense"
                            clearable
                          />
                        </v-col>
                        <v-col cols="12" md="3" sm="3" class="mb-0">
                          <v-text-field
                            v-model="portalVariantId"
                            :label="$t('portalVariantId')"
                            height="20"
                            dense
                            outlined
                            class="mb-1 dense"
                            clearable
                          />
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-tab-item>
                  <!-- <portal-3-integrator /> -->
                  <v-tab-item>
                    <Portal3Integrator
                      @updatePortal="getPortalPanels"
                      :portalPanel="portalPanel"
                    />
                  </v-tab-item>
                  <v-tab-item>
                    <sazito-integrator
                      @updateSazito="getSazitoPanels"
                      :sazitoPanel="sazitoPanel"
                    />
                  </v-tab-item>

                  <v-tab-item>
                    <v-container>
                      <v-row>
                        <v-col cols="12" md="3" sm="3" class="mb-0">
                          <v-text-field
                            v-model="webziId"
                            :label="$t('webziId')"
                            height="20"
                            dense
                            outlined
                            class="mb-1 dense"
                            clearable
                          />
                        </v-col>
                        <v-col cols="12" md="3" sm="3" class="mb-0">
                          <v-text-field
                            v-model="webziVariantId"
                            :label="$t('webziVariantId')"
                            height="20"
                            dense
                            outlined
                            class="mb-1 dense"
                            clearable
                          />
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-tab-item>
                  <v-tab-item>
                    <mixin-integrator
                      @updateMixin="getMixinPanels"
                      :mixinPanel="mixinPanel"
                    />
                  </v-tab-item>
                  <v-tab-item>
                    <snapshop-integrator
                      @updateSnapshop="getSnapshopPanels"
                      :snapshopPanel="snapshopPanel"
                    />
                  </v-tab-item>
                </v-tabs>
              </v-row>
            </v-container>
          </v-tab-item>
          <v-tab-item v-if="$store.state.shopSystem">
            <v-container>
              <v-row class="pa-0 ma-0">
                <v-col cols="12" class="my-0 px-1 py-0" style="height: auto !important">
                  <tiptap-vuetify
                    v-model="body"
                    :extensions="extensions"
                    :toolbar-attributes="{ color: '#ababab', dark: true }"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-tab-item>
        </v-tabs>
      </div>
      <v-card-actions class="pa-0 ma-0 create-simple-product-actions">
        <div class="create-simple-product-actions-wrap">
          <v-row class="ma-0 d-flex justify-space-between align-center">
            <v-col cols="6" class="px-1 d-flex align-start">
              <v-btn
                v-if="!id"
                v-shortkey="['shift', 'f3']"
                color="primary"
                class="ml-2"
                :loading="isLoading"
                @shortkey="shortkeyCreateSubmit"
                @click="create(true)"
              >
                {{ $t("submit") }}
              </v-btn>
              <v-btn
                v-if="!id"
                v-shortkey="['shift', 'f4']"
                color="primary"
                class="ml-2"
                :loading="isLoading"
                @shortkey="shortkeyCreateSubmitNew"
                @click="create(false)"
              >
                {{ $t("submit&new") }}
              </v-btn>
              <v-btn
                v-if="id"
                v-shortkey="['shift', 'f3']"
                color="primary"
                class="mr-0"
                :loading="isLoading"
                @shortkey="update"
                @click="update"
              >
                {{ $t("submit") }}
              </v-btn>
            </v-col>
            <v-col cols="6" class="px-2 d-flex align-center justify-end">
              <v-btn
                color="gray"
                class=""
                :loading="isLoading"
                outlined
                @click="triggertoAdvance"
              >
                {{ simple ? $t("create_advance_product") : $t("create_simple_product") }}
              </v-btn>
              <v-btn
                v-if="!formType"
                color="grey"
                outlined
                class="mr-3"
                @click="goTo(type == 'product' ? 'ProductList' : 'ServiceList')"
              >
                {{ type == "product" ? $t("productList") : $t("serviceList") }}
              </v-btn>
            </v-col>
          </v-row>
          <p class="create-simple-product-shortcuts-hint ma-0 ms-1">
            <template v-if="!id">
              Shift+F3 {{ $t("submit") }} · Shift+F4 {{ $t("submit&new") }}
            </template>
            <template v-else>Shift+F3 {{ $t("submit") }}</template>
          </p>
        </div>
      </v-card-actions>
    </v-form>
    <v-snackbar
      v-model="snakbar"
      :color="snakbarColor ? snakbarColor : 'primary'"
      top
      style="z-index: 1000000000000 !important"
    >
      {{ snakbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snakbar = !snakbar">
          {{ $t("close") }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
// import aicomplete from '../../components/general/AIcomplete/index'
import General from "../../../../Mixins/general";
// import Dropbox from '../../components/general/dropbox/index'
import filePicker from "../../components/general/filePicker/index";
import customFields from "../../components/general/customFields/index.vue";
import Pricing from "./pricing";
import DigikalaIntegrator from "./partial/DigikalaIntegrator";
import SazitoIntegrator from "./partial/SazitoIntegrator.vue";
import Portal3Integrator from "./partial/Portal3Integrator.vue";
import MixinIntegrator from "./partial/MixinIntegrator.vue";
import SnapshopIntegrator from "./partial/SnapshopIntegrator.vue";
import Description from "../../components/general/description/Description";
import VariableProductTab from "./partial/VariableProductTab.vue";
import {
  TiptapVuetify,
  Heading,
  Bold,
  Italic,
  Strike,
  Underline,
  Code,
  Paragraph,
  BulletList,
  OrderedList,
  ListItem,
  Link,
  Blockquote,
  HardBreak,
  HorizontalRule,
  History,
  Image,
  Table,
  TableCell,
  TableHeader,
  TableRow,
} from "tiptap-vuetify";

const DEFAULT_CARD_HEIGHT = "calc(100vh - 98px)";
const DEFAULT_SHOW_SIMPLE = false;
const DEFAULT_TOOLBAR_TITLE = true;

export default {
  name: "Product",
  components: {
    autocomplete: () => import("../../components/general/patial/autocomplete"),
    aicomplete: () => import("../../components/general/AIcomplete/index"),
    TiptapVuetify,
    customFields,
    filePicker,
    // Dropbox,
    Pricing,
    Tag: () => import("../../components/general/Tag/tag"),
    DigikalaIntegrator,
    SazitoIntegrator,
    Portal3Integrator,
    MixinIntegrator,
    SnapshopIntegrator,
    Description,
    VariableProductTab,
  },
  mixins: [General],
  props: {
    formType: {},
    idProp: {},
    invoiceTrigger: {},
    cardHeight: {
      type: String,
      default: DEFAULT_CARD_HEIGHT,
    },
    showSimple: {
      type: Boolean,
      default: DEFAULT_SHOW_SIMPLE,
    },
    toolbarTitle: {
      type: Boolean,
      default: DEFAULT_TOOLBAR_TITLE,
    },
  },
  data() {
    return {
      simple: this.showSimple,
      woocommerceIdItems: [],
      basalamIdItems: [],
      isVariableProduct: false,
      wasVariableProduct: false,
      has_serial: "deactive",
      productTab: 0,
      variableVariants: [],
      render: true,
      isKalaBarg: false,
      countWoocommercepanel: 1,
      taxPercent: 10,
      priceWithTax: 0,
      discountPercent: 0,
      initial_stocks: [],
      displayPriority: null,
      constructionWagesPercent: null,
      commissionPercent: null,
      profitPercent: null,
      discount: null,
      length: null,
      width: null,
      height: null,
      webziVariantId: null,
      webziId: null,
      sazitoVariantId: null,
      sazitoId: null,
      markitoId: null,
      defaultUnit: null,
      customFields: null,
      taxid: null,
      imagePicker: null,
      imagePickerVal: null,
      removeAvatar: false,
      productImages: null,
      productImagesVal: null,
      kind: null,
      body: null,
      digikalaPanel: [],
      sazitoPanel: [],
      portalPanel: [],
      mixinPanel: [],
      snapshopPanel: [],
      /* digikalaFixCount: null, */
      barcodes: [],
      allocations: [{ percent: null, from_date: null, to_date: null }],
      investors: [],
      units: [],
      sellCosts: [],
      extensions: [
        History,
        Table,
        TableCell,
        TableHeader,
        TableRow,
        Blockquote,
        Link,
        Underline,
        Strike,
        Italic,
        ListItem, // if you need to use a list (BulletList, OrderedList)
        BulletList,
        OrderedList,
        Image,
        [
          Heading,
          {
            // Options that fall into the tiptap's extension
            options: {
              levels: [1, 2, 3],
            },
          },
        ],
        Bold,
        Code,
        HorizontalRule,
        Paragraph,
        HardBreak, // line break on Shift + Ctrl + Enter
      ],
      isLoading: false,
      alert: false,
      inventoryMethod: "average",
      priceMethod: "max",
      priceMethodItems: [],
      portalId: null,
      portalVariantId: null,
      /* digikalaVariantId: null, */
      woocommerceId: null,
      initialCheck: true,
      pricing: null,
      woocommerceVariantId: null,
      woocommerceFixCount: null,
      image: null,
      costs: null,
      tag: null,
      weight: null,
      orderPoint: null,
      valid: null,
      message: null,
      alertType: null,
      name: null,
      group: null,
      cat1: null,
      cat2: null,
      unit: null,
      fee: null,
      count: 0,
      id: null,
      currency: null,
      status: "active",
      entrepot: null,
      barcode: null,
      code: 1,
      type: "product",
      timer: null,
      price: null,
      loading: false,
      custom_code: null,
      content: null,
      /** بعد از ثبت موفق زیاد می‌شود تا فرم و کامپوننت‌های فرزند از نو ساخته شوند */
      formResetKey: 0,
      panel: undefined,
    };
  },
  watch: {
    isVariableProduct(val) {
      if (this.wasVariableProduct && !val) {
        this.isVariableProduct = true;
      }
    },
    formType(val) {
      const normalized = (val || "").toLowerCase();
      if (["product", "service"].includes(normalized)) {
        this.type = normalized;
      }
    },
    idProp() {
      this.render = true;
      if (this.idProp != null) {
        this.id = this.idProp;
        this.show();
        this.render = false;
      } else {
        this.render = false;
      }
    },
    image() {},
    group(Val, oldVal) {
      if (this.$refs.refCat2 && this.$refs.refCat1) {
        if (Val) {
          this.$refs.refCat1.clear();
          this.$refs.refCat2.clear();
          this.$refs.refCat1.initList = false;
          this.$refs.refCat1.getItems();
        } else {
          this.$refs.refCat1.clear();
          this.$refs.refCat2.clear();
        }
      }
    },
    cat1(Val, oldVal) {
      if (this.$refs.refCat2) {
        if (Val) {
          this.$refs.refCat2.clear();
          this.$refs.refCat2.initList = false;
          this.$refs.refCat2.getItems();
        } else {
          this.$refs.refCat2.clear();
        }
      }
    },
  },
  computed: {
    normalizedFormType() {
      return (this.formType || "").toLowerCase();
    },
    showTypeSelector() {
      return !["product", "service"].includes(this.normalizedFormType);
    },
    isMobile() {
      return this.$vuetify.breakpoint.name === "sm";
    },
    cardHeightStyle() {
      const h = (this.cardHeight || "").trim();
      return { height: h || DEFAULT_CARD_HEIGHT };
    },
  },
  beforeMount() {
    this.inventoryMethodItems = [
      {
        value: "average",
        text: this.$t("weightedAverage"),
      },
      {
        value: "fifo",
        text: this.$t("fifo"),
      },
      {
        value: "lifo",
        text: this.$t("lifo"),
      },
    ];

    this.priceMethodItems = [
      {
        value: "first",
        text: this.$t("firstCost"),
      },
      {
        value: "min",
        text: this.$t("minCost"),
      },
      {
        value: "average",
        text: this.$t("averageCost"),
      },
      {
        value: "max",
        text: this.$t("maxCost"),
      },
      {
        value: "last",
        text: this.$t("lastCost"),
      },
    ];
    if (["product", "service"].includes(this.normalizedFormType)) {
      this.type = this.normalizedFormType;
    } else if (this.$route.name === "Service") {
      this.type = "service";
    } else {
      this.type = "product";
    }
    // const array = ['Product', 'Service']
    if (this.$route.params.id != null) {
      this.id = this.$route.params.id;
      this.show();
      this.render = false;
    } else {
      this.render = true;
      this.checkCode();
      // this.addInitialStock()
    }
    if (this.idProp != null && typeof this.idProp !== "undefined") {
      this.id = this.idProp;
      this.show();
      this.render = false;
    }
  },
  mounted() {
    this.$emit("trigger", this.simple);
    if (this.woocommerceIdItems.length === 0) {
      this.addWoocommerceIdItems();
    }
    if (this.basalamIdItems.length === 0) {
      this.addBaSalamIdItems();
    }
  },
  methods: {
    entrepotRuls(initial) {
      return Number(initial.stock) > 0 ? [(v) => !!v || this.$t("is-required")] : [];
    },
    shortkeyCreateSubmit() {
      this.create(true);
    },
    shortkeyCreateSubmitNew() {
      this.create(false);
    },
    buildProductPayload() {
      const payload = { ...this.$data };
      if (this.isVariableProduct) {
        payload.initial_stocks = [];
        payload.variants = (this.variableVariants || []).map((v) => ({
          id: v.id,
          name: v.name,
          baseName: v.baseName,
          attributes: v.attributes || [],
          sku: v.sku,
          code: v.code,
          custom_code: v.custom_code,
          displayPriority: v.displayPriority,
          status: v.status,
          taxid: v.taxid,
          taxPercent: v.taxPercent,
          price: v.price,
          priceWithTax: v.priceWithTax,
          discount: v.discount,
          discountPercent: v.discountPercent,
          isKalaBarg: v.isKalaBarg,
          barcode: v.barcode,
          barcodes: v.barcodes || [],
          tag: v.tag,
          pricing: v.pricing,
          length: v.length,
          width: v.width,
          height: v.height,
          weight: v.weight,
          orderPoint: v.orderPoint,
          investors: v.investors || [],
          initial_stocks: v.initial_stocks || [],
        }));
      } else {
        payload.variants = [];
      }
      payload.variantFields = (this.variableVariants || []).flatMap((v) =>
        (v.attributes || [])
          .filter((a) => a && a.key)
          .map((a) => ({ key: a.key, value: a.value }))
      );
      return payload;
    },
    addBaSalamIdItems() {
      var item = {
        basalamPanelName: null,
        basalamId: null,
        basalamVariantId: null,
      };
      this.basalamIdItems.push(item);
    },
    removeBaSalamId(item) {
      var i = this.basalamIdItems.indexOf(item);
      this.basalamIdItems.splice(i, 1);
    },
    addWoocommerceIdItems() {
      if (
        this.$store.state.allConfig &&
        this.$store.state.allConfig.countWoocommercePanel
      ) {
        this.countWoocommercepanel = this.$store.state.allConfig.countWoocommercePanel;
      }
      if (this.woocommerceIdItems.length < this.countWoocommercepanel) {
        var item = {
          woocommercePanelName: null,
          woocommerceId: null,
          woocommerceVariantId: null,
          woocommerceFixCount: null,
        };
        this.woocommerceIdItems.push(item);
      }
    },
    removeWoocommerceId(item) {
      var i = this.woocommerceIdItems.indexOf(item);
      this.woocommerceIdItems.splice(i, 1);
    },
    calcPrice() {
      if (this.taxPercent && this.taxPercent > 0) {
        clearTimeout(this.timer);
        var app = this;
        this.timer = setTimeout(function () {
          var tax = 0;
          var netPrice = +app.priceWithTax / (1 + +app.taxPercent / 100);
          tax = app.roundMath(
            +app.priceWithTax - +netPrice,
            app.$store.state.currency.decimal
          );
          var price = +app.priceWithTax - +tax;
          app.price = price;
        }, 1000);
      }
    },
    calcPriceWithTax() {
      if (this.taxPercent && this.taxPercent > 0) {
        var TaxAmount = +this.price * (1 + +this.taxPercent / 100);
        this.priceWithTax = +this.roundMath(
          TaxAmount,
          this.$store.state.currency.decimal
        );
      }
    },
    validateStock(initial) {
      setTimeout(function () {
        if (initial.stock < 0) {
          initial.stock = 0;
        }
      }, 50);
    },
    checkEntrepot(item, j) {
      var app = this;
      if (item.entrepot && this.initial_stocks.length > 1) {
        for (let i = 0; i < this.initial_stocks.length; i++) {
          const value = this.initial_stocks[i];
          if (
            j !== i &&
            value.entrepot &&
            value.entrepot.id &&
            value.entrepot.id === item.entrepot.id
          ) {
            setTimeout(function () {
              app.snakbarText = app.$t("selectedWarehouseIsdDuplicate");
              app.snakbarColor = "pink";
              app.snakbar = true;
              app.initial_stocks[j].entrepot = null;
            }, 200);
            break;
          }
        }
      }
    },
    addInitialStock() {
      var row = {
        stock: 0,
        price: 0,
        entrepot: null,
      };
      this.initial_stocks.push(row);
    },
    removeInitialStock(i) {
      this.initial_stocks.splice(i, 1);
    },
    changeInvestor(item) {
      if (!item.id) {
        if (item.investor) {
          item.investorSellPercent = item.investor.investorSellPercent;
          item.investorReturnSellPercent = item.investor.investorReturnSellPercent;
        } else {
          item.investorSellPercent = null;
          item.investorReturnSellPercent = null;
        }
      }
    },
    clearDefaultUnits(item, i) {
      this.units.map(function (value, index) {
        if (index !== i) {
          value.default = null;
        }
      });
    },
    removeUnit(item) {
      var i = this.units.indexOf(item);
      this.units.splice(i, 1);
    },
    removeBarcode(item) {
      var i = this.barcodes.indexOf(item);
      this.barcodes.splice(i, 1);
    },
    addUnitRow() {
      this.units.push({
        unit: null,
        value: null,
        default: null,
      });
    },
    addBarcode() {
      this.barcodes.push({
        value: null,
      });
    },
    //add allocations
    addAllocationRow() {
      this.allocations.push({
        percent: null,
        from_date: null,
        to_date: null,
      });
    },
    removeAllocation(item) {
      var i = this.allocations.indexOf(item);
      this.allocations.splice(i, 1);
    },
    //
    addInvestorRow() {
      this.investors.push({
        investor: null,
        investorSellPercent: null,
        investorReturnSellPercent: null,
      });
    },
    addSellCostRow() {
      this.sellCosts.push({
        detail: null,
        amount: null,
      });
    },
    removeInvestor(item) {
      var i = this.investors.indexOf(item);
      this.investors.splice(i, 1);
    },
    removeSellCost(item) {
      var i = this.sellCosts.indexOf(item);
      this.sellCosts.splice(i, 1);
    },
    onCancel() {
      window.JsBarcode(".barcode").init();
    },
    onPicked(files) {
      files.forEach((file) => {});
    },
    checkCode() {
      var app = this;
      app.loading = true;
      app.$axios
        .get(this.$endpoint + "products", {
          params: {
            checkCode: app.code,
            product_id: app.id,
          },
        })
        .then((res) => {
          res = res.data;
          app.code = res.data;
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    create(submitOnly = true, type = null) {
      if (!this.$refs.form.validate()) return false;
      var Submit = submitOnly === true;
      var app = this;
      app.alert = false;
      app.isLoading = true;
      app.currency = app.defaultCurrency;
      if (
        app.digikalaPanel != undefined &&
        app.sazitoPanel != undefined &&
        app.portalPanel != undefined &&
        app.mixinPanel != undefined &&
        app.snapshopPanel != undefined
      ) {
        if (
          app.digikalaPanel.length == 0 &&
          (app.sazitoPanel.length > 0 ||
            app.portalPanel.length > 0 ||
            app.mixinPanel.length > 0 ||
            app.snapshopPanel.length > 0)
        ) {
          app.digikalaPanel = ["empty"];
        }
        if (
          app.sazitoPanel.length == 0 &&
          app.portalPanel.length == 0 &&
          (app.digikalaPanel.length > 0 ||
            app.mixinPanel.length > 0 ||
            app.snapshopPanel.length > 0)
        ) {
          app.sazitoPanel = ["empty"];
          app.portalPanel = ["empty"];
        }
        if (
          app.mixinPanel.length == 0 &&
          (app.digikalaPanel.length > 0 ||
            app.sazitoPanel.length > 0 ||
            app.portalPanel.length > 0 ||
            app.snapshopPanel.length > 0)
        ) {
          app.mixinPanel = ["empty"];
        }
        if (
          app.snapshopPanel.length == 0 &&
          (app.digikalaPanel.length > 0 ||
            app.sazitoPanel.length > 0 ||
            app.portalPanel.length > 0 ||
            app.mixinPanel.length > 0)
        ) {
          app.snapshopPanel = ["empty"];
        }
      }
      app.$axios
        .post(app.$endpoint + "products", app.buildProductPayload())
        .then((res) => {
          app.snakbarText = app.$t("registered");
          app.snakbarColor = "green";
          app.snakbar = true;
          res = res.data;
          if (app.imagePicker) {
            app.$refs.refFilePicker.create(res.data.id);
          }
          if (app.productImages) {
            app.$refs.refProductImages.create(res.data.id);
          }
          if (app.id) {
            if (app.type === "product") {
              app.goTo("ProductList");
            } else {
              app.goTo("ServiceList");
            }
          } else {
            if (app.invoiceTrigger) {
              res = res.data;
              var product = {
                id: res.id,
                name: res.name,
                code: res.code,
                fin_id: res.fin_id,
                barcode: res.barcode,
                group_id: res.group_id,
                count: 0,
                unit_id: res.unit_id,
                price: res.price,
                custom_code: res.financial.custom_code,
                type: res.type,
                unit: {
                  id: app.unit.id,
                  name: app.unit.name,
                  fame: app.unit.name,
                },
                tax_percent: app.taxPercent,
                discount_percent: app.discountPercent,
              };
              app.$emit("addproduct", product);
            } else {
              app.$emit("input", res.data.data);
            }
            app.render = false;
            app.$nextTick(() => {
              app.render = true;
            });
          }
        })
        .catch((err) => {
          if (err.response && err.response.status === 409) {
            this.$store.commit("SET_PLAN_DIALOG", true);
          }
          this.serverErrorHandeler(err);
        })
        .finally(() => {
          this.isLoading = false;
          if (Submit === true) {
            app.$emit("close-create-modal");
            app.$emit("close", app.$route);
          }
          app.clearForm();
          // app.snakbar = false
        });
    },
    show() {
      var app = this;
      // app.clearForm()
      app.loading = true;
      app.clearing = true;
      app.showing = true;
      app.$axios
        .get(app.$endpoint + "products/" + app.id + "/edit", {
          params: {
            id: app.id,
          },
        })
        .then((res) => {
          app.$nextTick(() => {
            res = res.data;
            app.isKalaBarg = res.is_kala_barg ?? res.isKalaBarg ?? false;
            app.typeForm = res.type;
            app.type = res.type;
            app.id = res.id;
            app.woocommerceIdItems = res.woocommerceIdItems ? res.woocommerceIdItems : [];
            app.basalamIdItems = res.basalamIntegrator ? res.basalamIntegrator : [];
            app.branch = res.branch;
            app.name = res.name;
            app.status = res.status;
            app.taxid = res.taxid;
            app.content = res.content;
            app.barcodes = res.barcodes;
            app.code = res.code;
            app.initial_stocks = res.initial_stocks;
            app.taxPercent = res.tax_percent;
            app.profitPercent = res.profit_percent;
            app.commissionPercent = res.commission_percent;
            app.constructionWagesPercent = res.construction_wages_percent;
            app.discountPercent = res.discount_percent;
            app.customFields = res.custom_fields;
            // app.variableVariants = res.variable_variants || res.variants || [];
            app.variableVariants = (res.variable_variants || res.variants || []).map(
              (row) => {
                const v = row.variant || row;
                return {
                  id: v.id,
                  name: v.name,
                  baseName: v.name,
                  code: v.code,
                  price: v.price,
                  status: v.status || "active",
                  taxid: v.taxid,
                  taxPercent: v.tax_percent ?? v.taxPercent ?? 10,
                  discountPercent: v.discount_percent ?? v.discountPercent ?? 0,
                  barcode: v.barcode,
                  weight: v.weight,
                  orderPoint: v.order_point ?? v.orderPoint,
                  attributes: v.attributes || [],
                  barcodes: v.barcodes || [],
                  investors: v.investors || row.investors || [],
                  initial_stocks: v.initial_stocks || row.initial_stocks || [],
                  initialCheck:
                    v.initialCheck !== undefined
                      ? v.initialCheck
                      : row.initialCheck !== undefined
                      ? row.initialCheck
                      : undefined,
                };
              }
            );
            if (typeof res.is_variable_product !== "undefined") {
              app.isVariableProduct = !!res.is_variable_product;
            } else if (typeof res.isVariableProduct !== "undefined") {
              app.isVariableProduct = !!res.isVariableProduct;
            } else if (app.variableVariants.length) {
              app.isVariableProduct = true;
            }
            app.wasVariableProduct = app.isVariableProduct;
       
            app.has_serial = res.has_serial || "deactive";
            if (app.$route.query["variant-id"] && app.isVariableProduct) {
              app.$nextTick(() => {
                app.productTab = 1;
              });
            }
            app.imagePicker = res.avatar;
            app.imagePickerVal = res.avatar;
            app.productImages = res.product_images_val;
            app.productImagesVal = res.product_images_val;
            app.custom_code = res.financial.custom_code;
            app.weight = res.weight;
            app.discount = res.discount;
            app.width = res.width;
            app.height = res.height;
            app.length = res.length;
            app.price = res.price;
            app.units = res.units;
            app.kind = res.kind;
            app.pricing = res.pricing;
            app.costs = res.costs;
            app.orderPoint = res.order_point;
            app.barcode = res.barcode;
            app.initialCheck = res.initialCheck;
            app.markitoId = res.integrator.markitoId;
            app.basalamId = res.integrator.basalamId;
            app.basalamVariantId = res.integrator.basalamVariantId;
            app.webziVariantId = res.integrator.webziVariantId;
            app.webziId = res.integrator.webziId;
            app.sazitoVariantId = res.integrator.sazitoVariantId;
            app.sazitoId = res.integrator.sazitoId;
            app.portalId = res.integrator.portalId;
            app.portalVariantId = res.integrator.portalVariantId;
            /* app.digikalaVariantId = res.integrator.digikalaVariantId */
            /* app.digikalaFixCount = res.integrator.digikalaFixCount */
            app.woocommerceFixCount = res.integrator.woocommerceFixCount;
            app.woocommerceId = res.integrator.woocommerceId;
            app.body = res.shop ? res.shop.body : null;
            app.digikalaPanel = res.digikalaPanel ? res.digikalaPanel : null;
            app.sazitoPanel = res.sazitoPanel ? res.sazitoPanel : null;
            app.portalPanel = res.portalPanel ? res.portalPanel : null;
            app.mixinPanel = res.mixinPanel ? res.mixinPanel : null;
            app.snapshopPanel = res.snapshopPanel ? res.snapshopPanel : null;
            app.displayPriority = res.priority;
            app.woocommerceVariantId = res.integrator.woocommerceVariantId;
            app.inventoryMethod = res.inventory_method;
            app.investors = res.investors;
            app.allocations =
              res.product_allocation && res.product_allocation.length
                ? res.product_allocation.map((item) => ({
                    id: item.id,
                    percent: item.percent != null ? parseFloat(item.percent) : null,
                    from_date: app
                      .$moment(item.from_date)
                      .format(app.$store.state.date_format),
                    to_date: app
                      .$moment(item.to_date)
                      .format(app.$store.state.date_format),
                  }))
                : [{ percent: null, from_date: null, to_date: null }];
            app.sellCosts = res.sell_costs;
            if (app.type === "product" && res.initial) {
              app.count = res.initial.in;
              app.fee = res.initial.price;
              app.entrepot = res.initial.head ? res.initial.head.entrepot : null;
            }
            if (res.group) {
              app.group = res.group;
            }
            if (res.cat1) {
              app.cat1 = res.cat1;
            }
            if (res.cat2) {
              app.cat2 = res.cat2;
            }
            if (res.unit) {
              app.unit = res.unit;
            }
            if (res.tags) {
              app.tag = res.tags;
            }
            app.render = true;
            app.calcPriceWithTax();
            // app.content = res.content
            // app.$refs.refDescription.setData(res.content)
          });
        })
        .catch((err) => {
          app.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    update() {
      var app = this;
      app.isLoading = true;
      if (
        app.digikalaPanel != undefined &&
        app.sazitoPanel != undefined &&
        app.portalPanel != undefined &&
        app.mixinPanel != undefined &&
        app.snapshopPanel != undefined
      ) {
        if (
          app.digikalaPanel.length == 0 &&
          (app.sazitoPanel.length > 0 ||
            app.portalPanel.length > 0 ||
            app.mixinPanel.length > 0 ||
            app.snapshopPanel.length > 0)
        ) {
          app.digikalaPanel = ["empty"];
        }
        if (
          app.sazitoPanel.length == 0 &&
          app.portalPanel.length == 0 &&
          (app.digikalaPanel.length > 0 ||
            app.mixinPanel.length > 0 ||
            app.snapshopPanel.length > 0)
        ) {
          app.sazitoPanel = ["empty"];
          app.portalPanel = ["empty"];
        }
        if (
          app.mixinPanel.length == 0 &&
          (app.digikalaPanel.length > 0 ||
            app.sazitoPanel.length > 0 ||
            app.portalPanel.length > 0 ||
            app.snapshopPanel.length > 0)
        ) {
          app.mixinPanel = ["empty"];
        }
        if (
          app.snapshopPanel.length == 0 &&
          (app.digikalaPanel.length > 0 ||
            app.sazitoPanel.length > 0 ||
            app.Panel.portallength > 0 ||
            app.mixinPanel.length > 0)
        ) {
          app.snapshopPanel = ["empty"];
        }
      }
      app.removeAvatar = !!app.imagePickerVal && !app.imagePicker;
      app.$axios
        .put(
          app.$endpoint + "products/" + app.$route.params.id,
          app.buildProductPayload()
        )
        .then((res) => {
          res = res.data;
          if (app.imagePicker) {
            app.$refs.refFilePicker
              ? app.$refs.refFilePicker.create(app.$route.params.id)
              : null;
          }
          if (app.productImages) {
            app.$refs.refProductImages
              ? app.$refs.refProductImages.create(app.$route.params.id)
              : null;
          }
          app.$emit("close", app.$route);
          if (app.type === "product") {
            app.goTo("ProductList");
          } else {
            app.goTo("ServiceList");
          }
        })
        .catch((err) => {
          app.serverErrorHandeler(err);
        })
        .finally(() => {
          app.isLoading = false;
          // app.snakbar = false
          app.$emit("close-create-modal");
        });
    },
    getPanels(panels) {
      this.digikalaPanel = panels;
    },
    getSazitoPanels(panels) {
      this.sazitoPanel = panels;
    },
    getPortalPanels(panels) {
      this.portalPanel = panels;
    },
    getMixinPanels(panels) {
      this.mixinPanel = panels;
    },
    getSnapshopPanels(panels) {
      this.snapshopPanel = panels;
    },
    clearForm() {
      this.fee = null;
      this.count = 0;
      this.id = null;
      this.inventoryMethod = "fifo";
      this.priceMethod = "max";
      this.barcodes = null;
      this.woocommerceId = null;
      this.pricing = null;
      this.woocommerceVariantId = null;
      this.image = null;
      this.costs = null;
      this.tag = null;
      this.displayPriority = null;
      this.orderPoint = null;
      this.valid = null;
      this.message = null;
      this.alertType = null;
      this.name = null;
      this.group = null;
      this.cat1 = null;
      this.cat2 = null;
      // this.unit = null;
      this.currency = null;
      this.status = "active";
      this.entrepot = null;
      this.allocations = [{ percent: null, from_date: null, to_date: null }];
      this.digikalaPanel = [];
      this.sazitoPanel = [];
      this.portalPanel = [];
      this.isKalaBarg = false;
      this.mixinPanel = [];
      this.snapshopPanel = [];
      this.discountPercent = null;
      this.barcode = null;
      this.code = 1;
      this.price = null;
      this.custom_code = null;
      this.content = null;
      //add for simple type
      this.priceWithTax = 0;
      this.taxid = null;
      this.discount = null;
      this.branch = null;
      this.kind = null;
      this.variableVariants = [];
      this.isVariableProduct = false;
      this.wasVariableProduct = false;
      this.has_serial = "deactive"; 
      this.checkCode();
    },
    //advance — toggle
    triggertoAdvance() {
      this.simple = !this.simple;
      this.$emit("trigger", this.simple);
    },
  },
};
</script>

<style scoped>
.create-simple-product-card {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.create-simple-product-header {
  position: sticky;
  top: 2;
  z-index: 4;
  background: #fff;
  flex: 0 0 auto;
}
.product-type-toggle {
  display: inline-flex;
  align-items: center;
  background: #ffff;
  border-radius: 4px;
  border: 1px solid #bdbdbd;
  overflow: hidden;
}
.toggle-item {
  border: 0;
  background: transparent;
  color: #424242;
  font-size: 13px;
  font-weight: 500;
  line-height: 1;
  min-width: 74px;
  padding: 8px 16px;
  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease;
}
.toggle-item.active {
  background: #1976d2;
  color: #ffffff;
  font-weight: 600;
}
.toggle-item:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}
.create-simple-product-form {
  display: flex !important;
  flex-direction: column !important;
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
}
.create-simple-product-advance-scroll {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
}
.create-simple-product-advance-greeting {
  margin-left: 2px;
  margin-bottom: 4px;
  font-size: 14px;
}
.create-simple-product-advance-inputs-col-desktop {
  padding-right: 24px !important;
}
.create-simple-product-advance-inputs-col-mobile {
  padding-right: 12px !important;
}
.create-simple-product-simple-shell {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.create-simple-product-tabs.v-tabs {
  flex: 1 1 auto;
  min-height: 0;
  display: flex !important;
  flex-direction: column !important;
  overflow: hidden !important;
}
::v-deep .create-simple-product-tabs > .v-tabs-bar {
  flex: 0 0 auto !important;
}
::v-deep .create-simple-product-tabs > .v-tabs-items,
::v-deep .create-simple-product-tabs > .v-window {
  flex: 1 1 auto !important;
  min-height: 0 !important;
  overflow-y: auto !important;
  overflow-x: hidden !important;
  -webkit-overflow-scrolling: touch;
}
.create-simple-product-actions {
  position: sticky;
  bottom: 0;
  z-index: 4;
  background: #fff;
  flex: 0 0 auto;
  border-top: 1px solid #bdbdbd;
  min-height: 65px;
  padding: 4px 6px 6px !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: stretch !important;
}
.create-simple-product-actions-wrap {
  width: 100%;
  display: flex;
  flex-direction: column;
}
::v-deep .create-simple-product-actions .v-row {
  align-items: center;
  min-height: 44px;
}
::v-deep .create-simple-product-actions .v-col {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
::v-deep .create-simple-product-actions .v-btn {
  min-height: 30px !important;
  height: 30px !important;
}
.create-simple-product-shortcuts-hint {
  font-size: 10px;
  line-height: 1.35;
  color: #9e9e9e;
  padding: 0px 0px 0;
  width: 100%;
}
.v-input.v-textarea.v-textarea--auto-grow.v-textarea--no-resize.theme--light.v-text-field {
  height: 35px;
  border: 1px solid silver;
}
::v-deep .v-text-field.v-text-field--solo .v-input__control {
  height: 32px;
  margin-bottom: 0;
}
::v-deep .v-textarea.v-text-field--solo .v-input__append-outer {
  margin-top: 6px;
  margin-left: 8px;
}
::v-deep
  .v-textarea.v-text-field--enclosed.v-text-field--single-line:not(.v-input--dense)
  .v-label {
  top: 7px !important;
}
::v-deep
  .v-textarea.v-text-field--enclosed.v-text-field--single-line:not(.v-input--dense)
  textarea {
  margin-top: 4px;
}
::v-deep .v-textarea.v-text-field--solo .v-input__append-inner {
  margin-top: 5px;
}
</style>
